/** @jsx jsx */
/** @jsxRuntime classic */
import { jsx } from "@emotion/react";
import tw from "twin.macro";

const CometChatUserPresence = ({ status }) => {
  return (
    <span
      tw="absolute bottom-0 right-0 block h-3 w-3 rounded-full ring-2 ring-white bg-gray-300"
      css={[
        (status === "online" || status === "available") && tw`bg-green-400`,
      ]}
    />
  );
};

export default CometChatUserPresence;
